import React from 'react';

class TabBar extends React.Component {

    constructor(props) {
      super(props);
    }

    selected() {
        return this.props.tabs.indexOf(this.props.tab)
    }

    classAtIndex(i) {
        return ( i==this.selected() )?' tab_item_selected':''
    }

    onClick(i) {
        if ( i != this.selected() ) {
            this.props.setTab(this.props.tabs[i])
        }
    }

    render() {

        return <div className='tab_container'>
            {this.props.children}
            {this.props.tabs.map(
                (tab,i) => <div 
                    className={'tab_item'+this.classAtIndex(i)} 
                    onClick={this.onClick.bind(this,i)}
                    key={i}
                >
                    {tab}
                </div>
            )}
        </div>
    }
}

export default TabBar;